// src/components/Hero.jsx
import heroImg   from "../images/heroIMG.jpg";
import heroImg2x from "../images/heroIMG@2x.jpg";
import mobHero   from "../images/mobHERO.jpg";
import mobHero2x from "../images/mobHERO@2x.jpg";
import check    from "../images/tick.svg";
import arrow1   from "../images/arrow1.png";
import useNavi  from "../hooks/useNavi";

// ✅ No preload needed here anymore — App.jsx handles it at boot time
// ✅ Keeping imports so Vite/CRA bundles and hashes the filenames correctly

const Hero = () => {
  const features = [
    "Get qualified fast! We expedite the process so you can get your permit quickly.",
    "Complete your concealed carry application in less than 30 minutes with no required range training.",
    "Submit your application and receive your permit by mail to legally carry in over 50% of the country.",
  ];
  const btnNav = useNavi();

  return (
    <>
      <section
        className="relative pageEffect w-full bg-white"
      >
        <div className="relative hero-con  max-w-7xl mx-auto  items-center justify-center lg:justify-between px-6 lg:pl-20 lg:pr-10 py-10 lg:py-10 flex flex-col lg:flex-row  lg:items-start  gap-6 lg:gap-12">

          {/* Left: Heading + features + CTA */}
          <div className="flex-1 max-w-[480px] w-full hero-left">
            <h1 className="text-[2.15rem] font-black leading-[1.08] tracking-tight text-gray-900 mb-8 text-center lg:text-left">
              APPLY FOR A CONCEALED CARRY PERMIT LEGALLY IN A FEW SIMPLE STEPS.
            </h1>

            <ul className="space-y-5 mb-10 hero-list">
              {features.map((text, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="flex-shrink-0 mt-0.5 w-8 h-8 rounded-full flex items-center justify-center">
                    <img
                      className="check-icon"
                      src={check}
                      alt=""
                      width={438}
                      height={418}
                      loading="eager"
                    />
                  </span>
                  <p className="text-gray-700 text-[13.5px] leading-snug">{text}</p>
                </li>
              ))}
            </ul>

            {/* Desktop CTA */}
            <div className="hidden lg:block mb-6">
              <p style={{fontFamily:"Acumin Pro Condensed"}} className="text-left font-bold text-gray-700 text-[17px] leading-snug mb-3">
                Click the button to start the qualification process and<br />
                complete your application in as little as{" "}
                30 minutes.
              </p>
              <div className="relative">
                <img
                  className="arrow1 absolute pointer-events-none"
                  style={{ width: "64px", height: "auto", right: "calc(100% + 6px)", top: "50%", transform: "translateY(calc(-50% - 24px))" }}
                  src={arrow1}
                  alt=""
                  width={210}
                  height={211}
                />
                <button
                  onClick={btnNav}
                  className="hover:bg-green-600 active:scale-95 transition-all text-white font-bold text-[15px] tracking-wide px-10 py-4 rounded-full shadow-lg shadow-gray-300 hero-btn1 whitespace-nowrap"
                >
                  Get Qualified Now
                </button>
              </div>
            </div>

            {/* Mobile CTA */}
            <div className="flex flex-col items-center gap-3 lg:hidden mb-6">
              <p className="text-center text-gray-700 text-[13px] leading-snug">
                Click the button to start the qualification process and complete your application in as little as{" "}
                <span className="font-bold">30 minutes.</span>
              </p>
              <button
                onClick={btnNav}
                className="w-full hover:bg-green-600 active:scale-95 transition-all text-white font-bold text-[15px] tracking-wide px-8 py-4 rounded-full shadow-lg shadow-gray-300 hero-btn1 whitespace-nowrap text-center"
              >
                Get Qualified Today
              </button>
            </div>
          </div>

          {/* Right: hero photo */}
          <div className="flex flex-col items-center gap-4 w-full lg:flex-1 lg:max-w-[700px] hero-right">
            <div className="relative flex items-center justify-center w-full">
              <img
                src={mobHero}
                srcSet={`${mobHero} 1x, ${mobHero2x} 2x`}
                alt="Sample concealed carry permit"
                width={335}
                height={230}
                loading="eager"
                fetchpriority="high"
                decoding="async"
                className="block object-contain w-full lg:hidden"
              />
              <img
                src={heroImg}
                srcSet={`${heroImg} 1x, ${heroImg2x} 2x`}
                alt="Sample concealed carry permit"
                width={712}
                height={616}
                loading="eager"
                decoding="async"
                className="hidden lg:block object-contain w-full"
              />
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Hero;